
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-revise-question-answer-description',
  templateUrl: './revise-question-answer-description.component.html',
  styleUrls: ['./revise-question-answer-description.component.css']
})
export class ReviseQuestionAnswerDescriptionComponent implements OnInit {
  @Input() question= undefined
  explanations: any[] = []
  concepts: any[] = []
  constructor() { }

  ngOnInit(): void {
    if(this.question){
      this.explanations = this.question['answer_description']['explanation']
      this.concepts = this.question['answer_description']['concepts']
    }

  }

}
